export default __webpack_public_path__ + "static/media/interact.28eb1f90.svg";